import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { formatVP } from '../../../../helpers/helperFunctions';
import { CaptionText } from '../../../../styles/FontStyles';
import { color } from '../../../../styles/GlobalStyles';

export const RootTeamMemberInfo = ({ tab }) => {
  const { t } = useTranslation('myTeam');

  const { rootTeamMemberInfo, userAsTeamMemberInfo } = useSelector(
    (store) => store.myTeamBackoffice
  );

  return (
    <>
      <CaptionText center color={color.colors.neutral400} mbSM='6'>
        {t('country')}:{' '}
        <CaptionText bold inline color={color.colors.secondary100}>
          {tab === 'volume' || tab === 'generations'
            ? userAsTeamMemberInfo?.country
            : rootTeamMemberInfo?.country ?? '---'}
        </CaptionText>
      </CaptionText>

      <CaptionText center color={color.colors.neutral400} mbSM='6'>
        {t('rank')}:{' '}
        <CaptionText bold inline color={color.colors.secondary100}>
          {tab === 'volume' || tab === 'generations'
            ? userAsTeamMemberInfo?.userPackage?.packageRank?.name
            : rootTeamMemberInfo?.userPackage?.packageRank?.name ?? '---'}
        </CaptionText>
      </CaptionText>

      <CaptionText center color={color.colors.neutral400} mbSM='6'>
        {t('sponsor')}:{' '}
        <CaptionText bold inline color={color.colors.secondary100}>
          {rootTeamMemberInfo?.referrerUser ? (
            <span>
              {`${rootTeamMemberInfo?.referrerUser?.username || '---'}`} (#
              {rootTeamMemberInfo?.referrerUser?.id})
            </span>
          ) : (
            '---'
          )}
        </CaptionText>
      </CaptionText>
      <CaptionText
        center
        color={color.colors.neutral400}
        mbSM='5'
        mobile={true}>
        {t('direct_volume')}:{' '}
        <CaptionText bold inline color={color.colors.secondary100}>
          {formatVP(rootTeamMemberInfo?.directTotalVolume)}
        </CaptionText>
      </CaptionText>
    </>
  );
};
